/**
 * @fileoverview gRPC-Web generated client stub for stronachgroup.first.racehorse360
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v0.0.0
// source: stronachgroup/first/racehorse360/stall_application_service.proto

/* eslint-disable */
// @ts-nocheck

const grpc = {};
grpc.web = require("grpc-web");

var google_api_annotations_pb = require("../../../google/api/annotations_pb.js");

var google_api_visibility_pb = require("../../../google/api/visibility_pb.js");

var stronachgroup_first_racehorse360_messages_pb = require("../../../stronachgroup/first/racehorse360/messages_pb.js");
const proto = {};
proto.stronachgroup = {};
proto.stronachgroup.first = {};
proto.stronachgroup.first.racehorse360 = require("./stall_application_service_pb.js");

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient =
  function StallApplicationServiceClient(hostname, credentials, options) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient =
  function StallApplicationServicePromiseClient(
    hostname,
    credentials,
    options
  ) {
    if (!options) options = {};
    options.format = "text";

    /**
     * @private @const {!grpc.web.GrpcWebClientBase} The client
     */
    this.client_ = new grpc.web.GrpcWebClientBase(options);

    /**
     * @private @const {string} The hostname
     */
    this.hostname_ = hostname.replace(/\/+$/, "");
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListStallApplicationsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListStallApplicationsResponse>}
 */
const methodDescriptor_StallApplicationService_ListStallApplications =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/ListStallApplications",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListStallApplicationsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListStallApplicationsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListStallApplicationsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListStallApplicationsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListStallApplicationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListStallApplicationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListStallApplicationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.listStallApplications =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/ListStallApplications",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_ListStallApplications,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListStallApplicationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListStallApplicationsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.listStallApplications =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/ListStallApplications",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_ListStallApplications
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetStallApplicationRequest,
 *   !proto.stronachgroup.first.racehorse360.StallApplication>}
 */
const methodDescriptor_StallApplicationService_GetStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/GetStallApplication",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetStallApplicationRequest,
    stronachgroup_first_racehorse360_messages_pb.StallApplication,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetStallApplicationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.StallApplication.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.StallApplication)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.StallApplication>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.getStallApplication =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/GetStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_GetStallApplication,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.StallApplication>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.getStallApplication =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/GetStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_GetStallApplication
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteStallApplicationRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_StallApplicationService_DeleteStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStallApplication",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteStallApplicationRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteStallApplicationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.deleteStallApplication =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_DeleteStallApplication,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.deleteStallApplication =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_DeleteStallApplication
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UpdateStallApplicationRequest,
 *   !proto.stronachgroup.first.racehorse360.StallApplication>}
 */
const methodDescriptor_StallApplicationService_UpdateStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStallApplication",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UpdateStallApplicationRequest,
    stronachgroup_first_racehorse360_messages_pb.StallApplication,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UpdateStallApplicationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.StallApplication.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.StallApplication)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.StallApplication>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.updateStallApplication =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_UpdateStallApplication,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.StallApplication>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.updateStallApplication =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_UpdateStallApplication
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateStallApplicationRequest,
 *   !proto.stronachgroup.first.racehorse360.StallApplication>}
 */
const methodDescriptor_StallApplicationService_CreateStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/CreateStallApplication",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateStallApplicationRequest,
    stronachgroup_first_racehorse360_messages_pb.StallApplication,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateStallApplicationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.StallApplication.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.StallApplication)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.StallApplication>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.createStallApplication =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CreateStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_CreateStallApplication,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.StallApplication>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.createStallApplication =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CreateStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_CreateStallApplication
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SubmitStallApplicationRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_StallApplicationService_SubmitStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/SubmitStallApplication",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SubmitStallApplicationRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SubmitStallApplicationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SubmitStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.submitStallApplication =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SubmitStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_SubmitStallApplication,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SubmitStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.submitStallApplication =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SubmitStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_SubmitStallApplication
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.WithdrawStallApplicationRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_StallApplicationService_WithdrawStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/WithdrawStallApplication",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.WithdrawStallApplicationRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.WithdrawStallApplicationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.WithdrawStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.withdrawStallApplication =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/WithdrawStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_WithdrawStallApplication,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.WithdrawStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.withdrawStallApplication =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/WithdrawStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_WithdrawStallApplication
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CompleteStallApplicationRequest,
 *   !proto.stronachgroup.first.racehorse360.StallApplication>}
 */
const methodDescriptor_StallApplicationService_CompleteStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/CompleteStallApplication",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CompleteStallApplicationRequest,
    stronachgroup_first_racehorse360_messages_pb.StallApplication,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CompleteStallApplicationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.StallApplication.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CompleteStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.StallApplication)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.StallApplication>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.completeStallApplication =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CompleteStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_CompleteStallApplication,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CompleteStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.StallApplication>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.completeStallApplication =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CompleteStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_CompleteStallApplication
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest,
 *   !proto.stronachgroup.first.racehorse360.StallApplication>}
 */
const methodDescriptor_StallApplicationService_SaveDraftStallApplication =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/SaveDraftStallApplication",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SaveDraftStallApplicationRequest,
    stronachgroup_first_racehorse360_messages_pb.StallApplication,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.StallApplication.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.StallApplication)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.StallApplication>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.saveDraftStallApplication =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SaveDraftStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_SaveDraftStallApplication,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SaveDraftStallApplicationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.StallApplication>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.saveDraftStallApplication =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SaveDraftStallApplication",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_SaveDraftStallApplication
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListStableEntriesRequest,
 *   !proto.stronachgroup.first.racehorse360.ListStableEntriesResponse>}
 */
const methodDescriptor_StallApplicationService_ListStableEntries =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/ListStableEntries",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListStableEntriesRequest,
    stronachgroup_first_racehorse360_messages_pb.ListStableEntriesResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListStableEntriesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListStableEntriesResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListStableEntriesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListStableEntriesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListStableEntriesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.listStableEntries =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/ListStableEntries",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_ListStableEntries,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListStableEntriesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListStableEntriesResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.listStableEntries =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/ListStableEntries",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_ListStableEntries
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetStableEntryRequest,
 *   !proto.stronachgroup.first.racehorse360.StableEntry>}
 */
const methodDescriptor_StallApplicationService_GetStableEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/GetStableEntry",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetStableEntryRequest,
    stronachgroup_first_racehorse360_messages_pb.StableEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetStableEntryRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.StableEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetStableEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.StableEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.StableEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.getStableEntry =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/GetStableEntry",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_GetStableEntry,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetStableEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.StableEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.getStableEntry =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/GetStableEntry",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_GetStableEntry
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteStableEntryRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_StallApplicationService_DeleteStableEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStableEntry",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteStableEntryRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteStableEntryRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteStableEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.deleteStableEntry =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStableEntry",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_DeleteStableEntry,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteStableEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.deleteStableEntry =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStableEntry",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_DeleteStableEntry
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UpdateStableEntryRequest,
 *   !proto.stronachgroup.first.racehorse360.StableEntry>}
 */
const methodDescriptor_StallApplicationService_UpdateStableEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStableEntry",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UpdateStableEntryRequest,
    stronachgroup_first_racehorse360_messages_pb.StableEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UpdateStableEntryRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.StableEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateStableEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.StableEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.StableEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.updateStableEntry =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStableEntry",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_UpdateStableEntry,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateStableEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.StableEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.updateStableEntry =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStableEntry",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_UpdateStableEntry
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateStableEntryRequest,
 *   !proto.stronachgroup.first.racehorse360.StableEntry>}
 */
const methodDescriptor_StallApplicationService_CreateStableEntry =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/CreateStableEntry",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateStableEntryRequest,
    stronachgroup_first_racehorse360_messages_pb.StableEntry,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateStableEntryRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.StableEntry.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateStableEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.StableEntry)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.StableEntry>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.createStableEntry =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CreateStableEntry",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_CreateStableEntry,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateStableEntryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.StableEntry>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.createStableEntry =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CreateStableEntry",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_CreateStableEntry
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.GetStallApplicationFormRequest,
 *   !proto.stronachgroup.first.racehorse360.StallApplicationForm>}
 */
const methodDescriptor_StallApplicationService_GetStallApplicationForm =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/GetStallApplicationForm",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.GetStallApplicationFormRequest,
    stronachgroup_first_racehorse360_messages_pb.StallApplicationForm,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.GetStallApplicationFormRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.StallApplicationForm.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetStallApplicationFormRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.StallApplicationForm)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.StallApplicationForm>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.getStallApplicationForm =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/GetStallApplicationForm",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_GetStallApplicationForm,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.GetStallApplicationFormRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.StallApplicationForm>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.getStallApplicationForm =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/GetStallApplicationForm",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_GetStallApplicationForm
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_StallApplicationService_DeleteStallApplicationForm =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStallApplicationForm",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.DeleteStallApplicationFormRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.deleteStallApplicationForm =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStallApplicationForm",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_DeleteStallApplicationForm,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.DeleteStallApplicationFormRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.deleteStallApplicationForm =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/DeleteStallApplicationForm",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_DeleteStallApplicationForm
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest,
 *   !proto.stronachgroup.first.racehorse360.StallApplicationForm>}
 */
const methodDescriptor_StallApplicationService_UpdateStallApplicationForm =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStallApplicationForm",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.UpdateStallApplicationFormRequest,
    stronachgroup_first_racehorse360_messages_pb.StallApplicationForm,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.StallApplicationForm.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.StallApplicationForm)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.StallApplicationForm>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.updateStallApplicationForm =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStallApplicationForm",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_UpdateStallApplicationForm,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.UpdateStallApplicationFormRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.StallApplicationForm>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.updateStallApplicationForm =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/UpdateStallApplicationForm",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_UpdateStallApplicationForm
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.CreateStallApplicationFormRequest,
 *   !proto.stronachgroup.first.racehorse360.StallApplicationForm>}
 */
const methodDescriptor_StallApplicationService_CreateStallApplicationForm =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/CreateStallApplicationForm",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.CreateStallApplicationFormRequest,
    stronachgroup_first_racehorse360_messages_pb.StallApplicationForm,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.CreateStallApplicationFormRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.StallApplicationForm.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateStallApplicationFormRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.StallApplicationForm)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.StallApplicationForm>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.createStallApplicationForm =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CreateStallApplicationForm",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_CreateStallApplicationForm,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.CreateStallApplicationFormRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.StallApplicationForm>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.createStallApplicationForm =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/CreateStallApplicationForm",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_CreateStallApplicationForm
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.ListStallApplicationFormsRequest,
 *   !proto.stronachgroup.first.racehorse360.ListStallApplicationFormsResponse>}
 */
const methodDescriptor_StallApplicationService_ListStallApplicationForms =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/ListStallApplicationForms",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.ListStallApplicationFormsRequest,
    stronachgroup_first_racehorse360_messages_pb.ListStallApplicationFormsResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.ListStallApplicationFormsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.ListStallApplicationFormsResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListStallApplicationFormsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.ListStallApplicationFormsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.ListStallApplicationFormsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.listStallApplicationForms =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/ListStallApplicationForms",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_ListStallApplicationForms,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.ListStallApplicationFormsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.ListStallApplicationFormsResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.listStallApplicationForms =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/ListStallApplicationForms",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_ListStallApplicationForms
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SetFacilityOptionsRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_StallApplicationService_SetFacilityOptions =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/SetFacilityOptions",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SetFacilityOptionsRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SetFacilityOptionsRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetFacilityOptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.setFacilityOptions =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SetFacilityOptions",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_SetFacilityOptions,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetFacilityOptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.setFacilityOptions =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SetFacilityOptions",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_SetFacilityOptions
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.SetFacilityPreferencesRequest,
 *   !proto.stronachgroup.first.racehorse360.EmptyResponse>}
 */
const methodDescriptor_StallApplicationService_SetFacilityPreferences =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/SetFacilityPreferences",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.SetFacilityPreferencesRequest,
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.SetFacilityPreferencesRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.EmptyResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetFacilityPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.EmptyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.EmptyResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.setFacilityPreferences =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SetFacilityPreferences",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_SetFacilityPreferences,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.SetFacilityPreferencesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.EmptyResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.setFacilityPreferences =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/SetFacilityPreferences",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_SetFacilityPreferences
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest,
 *   !proto.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse>}
 */
const methodDescriptor_StallApplicationService_PullStallApplicationFormTermsFileSignedUrl =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/PullStallApplicationFormTermsFileSignedUrl",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullStallApplicationFormTermsFileSignedUrlRequest,
    stronachgroup_first_racehorse360_messages_pb.PullStallApplicationFormTermsFileSignedUrlResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullStallApplicationFormTermsFileSignedUrlResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.pullStallApplicationFormTermsFileSignedUrl =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/PullStallApplicationFormTermsFileSignedUrl",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_PullStallApplicationFormTermsFileSignedUrl,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullStallApplicationFormTermsFileSignedUrlResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.pullStallApplicationFormTermsFileSignedUrl =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/PullStallApplicationFormTermsFileSignedUrl",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_PullStallApplicationFormTermsFileSignedUrl
    );
  };

/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest,
 *   !proto.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse>}
 */
const methodDescriptor_StallApplicationService_PullStallApplicationFormSummary =
  new grpc.web.MethodDescriptor(
    "/stronachgroup.first.racehorse360.StallApplicationService/PullStallApplicationFormSummary",
    grpc.web.MethodType.UNARY,
    stronachgroup_first_racehorse360_messages_pb.PullStallApplicationFormSummaryRequest,
    stronachgroup_first_racehorse360_messages_pb.PullStallApplicationFormSummaryResponse,
    /**
     * @param {!proto.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest} request
     * @return {!Uint8Array}
     */
    function (request) {
      return request.constructor.encode(request).finish();
    },
    stronachgroup_first_racehorse360_messages_pb.PullStallApplicationFormSummaryResponse.decode
  );

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.stronachgroup.first.racehorse360.StallApplicationServiceClient.prototype.pullStallApplicationFormSummary =
  function (request, metadata, callback) {
    return this.client_.rpcCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/PullStallApplicationFormSummary",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_PullStallApplicationFormSummary,
      callback
    );
  };

/**
 * @param {!proto.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.stronachgroup.first.racehorse360.PullStallApplicationFormSummaryResponse>}
 *     Promise that resolves to the response
 */
proto.stronachgroup.first.racehorse360.StallApplicationServicePromiseClient.prototype.pullStallApplicationFormSummary =
  function (request, metadata) {
    return this.client_.unaryCall(
      this.hostname_ +
        "/stronachgroup.first.racehorse360.StallApplicationService/PullStallApplicationFormSummary",
      request,
      metadata || {},
      methodDescriptor_StallApplicationService_PullStallApplicationFormSummary
    );
  };

module.exports = proto.stronachgroup.first.racehorse360;
